import { CaretLeftIcon } from '@phosphor-icons/react';
import Button from 'components/Button';
import Container from 'components/Container';
import PublicFilePopupUpload from 'components/PublicFilePopupUpload';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function PublicFile() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const [uploadPopup, setUploadPopup] = useState(false);


    const openUploadHandler = () => {
        setUploadPopup(true);
    }

    return (
        <>
            <Container>
                <div className='flex gap-3 items-center pb-8 pt-20 md:pt-14'>
                    <div className='flex-1 flex items-center gap-3'>
                        <Link to={`/settings`} className=''>
                            <CaretLeftIcon size={26} className='hover:text-muted' />
                        </Link>
                        <p className='text-3xl'>Verifica file pubblico</p>
                    </div>
                    <Button onClick={openUploadHandler}>Carica nuovo file</Button>
                </div>

            </Container>

            <PublicFilePopupUpload
                visible={uploadPopup}
                setVisible={setUploadPopup}
            />
        </>
    )
}
